import { Route, Routes } from 'react-router-dom';
import { RoutePaths } from '@shared/utils';
import { PrivateRoute } from './privateRoute';
import {
  LoginPage,
  LoginCodePage,
  RegisterPage,
  MasterKeyPage,
  RegisterCodePage,
  RegisterOkPage,
  RecoveryPage,
  ForgotPage,
  RecoveryCodePage,
  RecoveryOkPage,
  ContactPage,
  ConditionsCardPolicyPage,
  ConditionsPolicyPage,
  CookiesPolicyPage,
  FaqPage,
  PrivacyPolicyPage,
  TariffPage,
  NotFoundPage,
  CardsPage,
  SecurityAnswersPage,
  ProfilePage,
  ProductsPage,
  ManageCardsPage,
  EligibilityFormPage,
  DisputedChargesPage,
  LettersPage,
} from '@pages';

export const Root = () => {
  return (
    <Routes>
      {/* AUTH */}
      <Route path={RoutePaths.login.path} element={<LoginPage />} />
      <Route path={RoutePaths.loginCode.path} element={<LoginCodePage />} />
      <Route path={RoutePaths.register.path} element={<RegisterPage />} />
      <Route path={RoutePaths.masterKey.path} element={<MasterKeyPage />} />
      <Route path={RoutePaths.registerCode.path} element={<RegisterCodePage />} />
      <Route path={RoutePaths.recoveryOk.path} element={<RegisterOkPage />} />
      <Route path={RoutePaths.recovery.path} element={<RecoveryPage />} />
      <Route path={RoutePaths.forgot.path} element={<ForgotPage />} />
      <Route path={RoutePaths.recoveryCode.path} element={<RecoveryCodePage />} />
      <Route path={RoutePaths.recoveryOk.path} element={<RecoveryOkPage />} />
      {/* PUBLIC */}
      <Route path={RoutePaths.contact.path} element={<ContactPage />} />
      <Route path={RoutePaths.privacy.path} element={<PrivacyPolicyPage />} />
      <Route path={RoutePaths.cook.path} element={<CookiesPolicyPage />} />
      <Route path={RoutePaths.conditions.path} element={<ConditionsPolicyPage />} />
      <Route path={RoutePaths.conditionsCard.path} element={<ConditionsCardPolicyPage />} />
      <Route path={RoutePaths.faq.path} element={<FaqPage />} />
      <Route path={RoutePaths.tariff.path} element={<TariffPage />} />
      {/* PRIVATE */}
      <Route
        path={RoutePaths.home.path}
        element={
          <PrivateRoute>
            <ManageCardsPage />
          </PrivateRoute>
        }
      />
      <Route
        path={RoutePaths.cards.path}
        element={
          <PrivateRoute>
            <CardsPage />
          </PrivateRoute>
        }
      />
      <Route
        path={RoutePaths.profileSecurityAnswers.path}
        element={
          <PrivateRoute>
            <SecurityAnswersPage />
          </PrivateRoute>
        }
      />
      <Route
        path={RoutePaths.profile.path}
        element={
          <PrivateRoute>
            <ProfilePage />
          </PrivateRoute>
        }
      />
      <Route
        path={RoutePaths.products.path}
        element={
          <PrivateRoute>
            <ProductsPage />
          </PrivateRoute>
        }
      />
      <Route
        path={RoutePaths.manageCards.path}
        element={
          <PrivateRoute>
            <ManageCardsPage />
          </PrivateRoute>
        }
      />
      <Route
        path={RoutePaths.form.path}
        element={
          <PrivateRoute>
            <EligibilityFormPage />
          </PrivateRoute>
        }
      />
      <Route
        path={RoutePaths.disputedCharges.path}
        element={
          <PrivateRoute>
            <DisputedChargesPage />
          </PrivateRoute>
        }
      />
      <Route
        path={RoutePaths.letters.path}
        element={
          <PrivateRoute>
            <LettersPage />
          </PrivateRoute>
        }
      />
      <Route path='*' element={<NotFoundPage />} />
    </Routes>
  );
};
